import React, { useEffect, useState } from "react";
import InvoiceDetails from "../../../components/FundingEvaluation/PaymentModule/InvoiceDetails";
import "./style.scss";
// import fibonatix from "../../../assets/images/paypal.png";
import axios from "axios";
import { countries } from "country-data";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import CheckSolidGreenIcon from "../../../assets/images/Paytiko_id1FrDBxXR_1.svg";
import Paymid from "../../../assets/images/paymid.png"
import paytikoLogo from "../../../assets/icons/check-solid-green.svg";
import COIN from "../../../assets/icons/coin_icon.svg";
import USDT from "../../../assets/images/USDT_ICON.png";
import TRX from "../../../assets/images/tron-trx-logo.png";
import fibonatix from "../../../assets/images/fibonatix2.png";
import nace from "../../../assets/images/nace.jpg";
import rapyd from "../../../assets/images/rapyd.png";
import Paypal from "../../../assets/images/paypal2.png";
import Summary from "../../../components/FundingEvaluation/PaymentModule/Summary";
import { newCryptoSelectorStyles, newSelectorStyles } from "../../../customstyle/customstyle";
import { setSelectedChallenge } from "../../../store/reducers/accountSlice";
import { returnErrors } from "../../../store/reducers/error";
import { setUser } from "../../../store/reducers/userSlice";
import { baseUrl, getUserDetails } from "../../../utils/apis";
import { countryStates } from "../../../utils/constants/countriesAndStates";
import { formatUSD, validateEmail } from "../../../utils/helpers/string";

const transformCountryData = (data) => {
  return data?.map((country) => ({
    label: country.name,
    value: country.code2,
    states: country.states,
    code2: country.code2,
  }));
};
const transformStateData = (states) => {
  return states?.map((state) => ({
    label: state.name,
    value: state.code,
  }));
};

const BuyFundedAc = ({ publicCheckout }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();

  const plans = useSelector((state) => state.account.plans?.data);
  const selectedChallenge = useSelector((state) => state.account.selectedChallenge);
  const userDATA = useSelector((state) => state.user);

  const savedCheckout = (() => {
    try {
      const isPaymentInProgress = localStorage.getItem("payment_in_progress") === "true";
      if (isPaymentInProgress) {
        return JSON.parse(localStorage.getItem("checkout_details") || "null");
      }
      return null;
    } catch (e) {
      return null;
    }
  })();

  const [selectedCountry, setSelectedCountry] = useState(savedCheckout?.selectedCountry || null);
  const [selectedState, setSelectedState] = useState(savedCheckout?.selectedState || null);
  const [countryCode, setCountryCode] = useState(savedCheckout?.countryCode || "");

  const [addressDetails, setAddressDetails] = useState(savedCheckout?.addressDetails || {
    zipCode: "",
    city: "",
    phone: "",
  });

  const handleCountryChange = (selectedOption) => {
    if (selectedOption.label === "United States") {
      setSelectedValue(planOptions[0]);
    }
    setSelectedCountry(selectedOption);
    setSelectedState(null);

    // Try code2 first (local countries), then value (Paytiko countries)
    const countryCode = selectedOption?.code2 || selectedOption?.value;
    const countryForCode = countries[countryCode?.toUpperCase()];
    const code = countryForCode?.countryCallingCodes?.[0] || "";

    setCountryCode(code);
    setFormData((prevData) => ({
      ...prevData,
      country: selectedOption?.value,
      country_code: code,
    }));
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
  };

  const countryUser = useSelector((state) => state.user.country);
  const dispatch = useDispatch();
  const [broker, setBroker] = useState(savedCheckout?.broker || "");
  const [showMT5Warning, setShowMT5Warning] = useState(false);

  // Create countryOptions, removing Malaysia and Canada if user is from Poland
  let countryOptions = transformCountryData(countryStates);
  if (countryUser === "Poland") {
    countryOptions = countryOptions.filter((country) => country.label !== "Malaysia" && country.label !== "Canada");
  }
  // Note: US and Canada are now visible even with MT5 selected
  // When selected, the useEffect will auto-switch to Match-Trader and show warning

  const stateOptions = selectedCountry ? transformStateData(selectedCountry.states) : [];

  useEffect(() => {
    if (selectedChallenge !== id) {
      dispatch(setSelectedChallenge(Number(id)));
    }
    if (id) {
      localStorage.setItem("checkout_challenge_id", id);
    }
  }, [plans, id]);

  const [rapydCountry, setRapydCountry] = useState();
  const [selectRapydCountry, setSelectRapydCountry] = useState(savedCheckout?.selectRapydCountry || null);
  const [paymidCountry, setPaymidCountry] = useState();
  const [selectPaymidCountry, setSelectPaymidCountry] = useState(savedCheckout?.selectPaymidCountry || null);

  useEffect(() => {
    const getRapydCountry = async () => {
      try {
        const response = await axios.get(`${baseUrl}/payment/paytiko-countries/`);
        const countryOptions = response?.data?.data?.map((country) => ({ label: country.name, value: country.code }));
        setRapydCountry(countryOptions);
      } catch (error) {
        console.error("Error fetching Rapyd countries:", error);
      }
    };

    getRapydCountry();
  }, []);

  useEffect(() => {
    const getPaymidCountry = async () => {
      try {
        const response = await axios.get(`${baseUrl}/payment/paymid-countries/`);
        const countryOptions = response?.data?.data?.map((country) => ({ label: country.name, value: country.code }));
        setPaymidCountry(countryOptions);
      } catch (error) {
        console.error("Error fetching Paymid countries:", error);
      }
    };

    getPaymidCountry();
  }, []);

  useEffect(() => {
    document.body.style.overflow = "auto";

    return () => {
      document.body.style.overflow = "";
    };
  }, [publicCheckout]);


  const options1 = [
    {
      active: "rapyd",
      value: "rapyd",
      label: (
        <div className="pmtOptions">
          <img
            style={{ objectFit: "contain" }}
            src={rapyd}
            alt="rapyd"
          />
          <span style={{ fontSize: "14px", textWrap: "nowrap" }}>Pay with Card/Apple/Google Pay</span>
        </div>
      ),
    },
    {
      active: "paytiko",
      value: "paytiko",
      label: (
        <div className="pmtOptions">
          <img
            src={CheckSolidGreenIcon}
            alt=""
            style={{ objectFit: "contain" }}
          />
          <span style={{ fontSize: "14px" }}>Pay with Card/Crypto/Paypal/UPI/Other (Worldwide)</span>
        </div>
      ),
    },
    {
      active: "paymid",
      value: "Paymid",
      label: (
        <div className="pmtOptions">
          <img
            src={Paymid}
            alt=""
            style={{ objectFit: "contain" }}
          />
          <span style={{ fontSize: "14px" }}>Pay with Card/Crypto/Paypal/UPI/Other (Worldwide)</span>
        </div>
      ),
    },
    // {
    //   active: "coinpayments",
    //   value: "coinpayments",
    //   label: (
    //     <div className="pmtOptions">
    //       <img
    //         src={COIN}
    //         alt=""
    //         style={{objectFit: "contain"}}
    //       />
    //       <span style={{fontSize: "14px"}}>Pay with Crypto (Coinpayments)</span>
    //     </div>
    //   ),
    // },

    // {
    //   active: "stripe",
    //   value: "stripe",
    //   label: (
    //     <div
    //       style={{
    //         display: "flex",
    //         width: "23px",
    //         alignItems: "center",
    //         gap: "20px",
    //       }}
    //     >
    //       {/* <img style={{ width: "100%" }} src={stripeIcon} loading="lazy" alt="" /> */}
    //       <img style={{ width: "100%" }} src={paypal} alt="" />
    //       <span style={{ fontSize: "14px", textWrap: "nowrap"}}>Pay with card</span>
    //     </div>
    //   ),
    // },

    // {
    //   active: "paypal",
    //   value: "paypal",
    //   label: (
    //     <div
    //       style={{
    //         display: "flex",
    //         width: "20px",
    //         borderRadius: "3px",
    //         padding: "2px",
    //         alignItems: "center",
    //         gap: "20px",
    //         widows: "100%",
    //       }}
    //     >
    //       <img  src={paypal} alt="" />
    //       <div style={{ fontSize: "14px" , textWrap: "nowrap"}}>Pay with card</div>
    //     </div>
    //   ),
    // },
    // userDATA?.country != "United States" && {
    //   active: "fibonatix",
    //   value: "fibonatix",
    //   label: (
    //     <div className="pmtOptions">
    //       <img
    //         src={fibonatix}
    //         alt=""
    //         style={{ objectFit: "contain" }}
    //       />
    //       <span style={{ fontSize: "14px", textWrap: "nowrap" }}>Pay with Card (Fibonatix)</span>
    //     </div>
    //   ),
    // },

    //     <div className="pmtOptions">
    //       <img
    //         src={nace}
    //         alt=""
    //         style={{objectFit: "contain"}}
    //       />
    //       <span style={{fontSize: "14px"}}>USDC/BTC/ETH</span>
    //     </div>
    //   ),
    // },
  ].filter(Boolean);

  const paymentModeOptions = [
    // {
    //   value: "BTC",
    //   label: (
    //     <div className="pmtOptions">
    //       <span style={{fontSize: "14px"}}>BTC</span>
    //     </div>
    //   ),
    // },
    {
      value: "BCH",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>BCH</span>
        </div>
      ),
    },
    {
      value: "LTC",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>LTC</span>
        </div>
      ),
    },
    {
      value: "BNB.BSC",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>BNB.BSC</span>
        </div>
      ),
    },
    // {
    //   value: "ETH",
    //   label: (
    //     <div className="pmtOptions">
    //       <span style={{fontSize: "14px"}}>ETH</span>
    //     </div>
    //   ),
    // },
    {
      value: "LINK",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>LINK</span>
        </div>
      ),
    },
    {
      value: "POL",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>POL</span>
        </div>
      ),
    },
    {
      value: "SHIB",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>SHIB</span>
        </div>
      ),
    },
    {
      value: "SOL",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>SOL</span>
        </div>
      ),
    },
    // {
    //   value: "USDC.ERC20",
    //   label: (
    //     <div className="pmtOptions">
    //       <span style={{fontSize: "14px"}}>USDC.ERC20</span>
    //     </div>
    //   ),
    // },
    {
      value: "USDC.BEP20",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>USDC.BEP20</span>
        </div>
      ),
    },
    {
      value: "USDT.ERC20",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>USDT.ERC20</span>
        </div>
      ),
    },
    {
      value: "USDT.BEP20",
      label: (
        <div className="pmtOptions">
          <span style={{ fontSize: "14px" }}>USDT.BEP20</span>
        </div>
      ),
    },
  ];

  const [paymentMethod, setPaymentMethod] = useState(
    options1.find((opt) => opt.value === savedCheckout?.paymentMethodValue) || options1[0]
  );

  const [paymentMode, setPaymentMode] = useState(paymentModeOptions[0]);

  const [selectedAddress, setSelectedAddress] = useState(null);
  const user = useSelector((state) => state?.user);

  const handlePaymentMethodChange = (selectedOption) => {
    setCountryCode(null);
    // setFormData({...formData, country_code: null});

    if (selectedOption.value === "coinpayments") {
      setOpenCoinPaymentsModal(true);
    }

    setPaymentMethod(selectedOption);

    // Reset country and state if payment method is not fibonatix
    if (selectedOption.value !== "fibonatix") {
      setSelectedCountry(null);
      setSelectedState(null);
    }
    setSelectRapydCountry(null);
    setSelectPaymidCountry(null);
  };

  const handlePaymentModChange = (selectedOption) => {
    setPaymentMode(selectedOption);
    // if(selectedOption.value === "")
  };

  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const planOptions = plans?.map((plan) => {
    let cleanName = plan?.name
      // Remove 'EE Challenge' at the end
      ?.replace(/EE Challenge\s*$/i, "")
      // Remove 'Challenge' at the end (if not already removed)
      ?.replace(/Challenge\s*$/i, "")
      // Remove 'Account' at the end
      ?.replace(/Account\s*$/i, "")
      ?.replace(/\s+/g, " ") // collapse multiple spaces
      ?.trim();
    return {
      label: <span style={{ textTransform: "capitalize " }}>{cleanName}</span>,
      value: cleanName,
      id: plan?.id,
    };
  });

  const handleBroker = (selectedOption) => {
    setBroker(selectedOption?.value);
  };

  const [accBalanceOptions, setAccBalanceOptions] = useState([]);
  const [currentChallenge, setCurrentChallenge] = useState(null);

  const [accBalance, setAccBalance] = useState("");
  const [selectedValue, setSelectedValue] = useState(planOptions.find((plan) => plan.id === currentChallenge?.id) || planOptions[0]);

  const paymentAsPerPlan = [
    {
      amount: 2500,
      step: "1 Step",
      link: "https://square.equityedge.co.uk/product/2-5k-challenge-1-step/5?cs=true&cst=custom",
    },
    {
      amount: 2500,
      step: "2 Step",
      link: "https://square.equityedge.co.uk/product/2-5k-challenge-2-step/7?cs=true&cst=custom",
    },

    {
      amount: 5000,
      step: "1 Step",
      link: "https://square.equityedge.co.uk/product/5k-challenge-1-step/1?cs=true&cst=custom",
    },
    {
      amount: 5000,
      step: "2 Step",
      link: "https://square.equityedge.co.uk/product/5k-challenge-2-step/8?cs=true&cst=custom",
    },

    {
      amount: 10000,
      step: "1 Step",
      link: "https://square.equityedge.co.uk/product/10k-challenge-1-step/2?cs=true&cst=custom",
    },
    {
      amount: 10000,
      step: "2 Step",
      link: "https://square.equityedge.co.uk/product/10k-challenge-2-step/9?cs=true&cst=custom",
    },

    {
      amount: 25000,
      step: "1 Step",
      link: "https://square.equityedge.co.uk/product/25k-challenge-1-step/4?cs=true&cst=custom",
    },
    {
      amount: 25000,
      step: "2 Step",
      link: "https://square.equityedge.co.uk/product/25k-challenge-2-step/10?cs=true&cst=custom",
    },

    {
      amount: 50000,
      step: "1 Step",
      link: "https://square.equityedge.co.uk/product/50k-challenge-1-step/15?cp=true&sa=false&sbp=false&q=false&category_id=AF4YMRW7MET2WSF3GVKCKOHU",
    },
    {
      amount: 50000,
      step: "2 Step",
      link: "https://square.equityedge.co.uk/product/50k-challenge-2-step/11?cs=true&cst=custom",
    },
    {
      amount: 100000,
      step: "1 Step",
      link: "https://square.equityedge.co.uk/product/100k-challenge-1-step/16?cp=true&sa=true&sbp=false&q=false",
    },
    {
      amount: 100000,
      step: "2 Step",
      link: "https://square.equityedge.co.uk/product/100k-challenge-2-step/16?cp=true&sa=true&sbp=false&q=false",
    },
  ];

  // Show only MT5 if user is from Poland
  const isPoland = selectedCountry?.label === "Poland" || countryUser === "Poland";
  // Show only Match-Trader and MT5 if user is from Malaysia
  const isMalaysia = selectedCountry?.label === "Malaysia" || countryUser === "Malaysia";
  const isUS_Canada = selectedCountry?.label === "United States" || selectedCountry?.label === "Canada" || countryUser === "United States" || countryUser === "Canada";

  let tradingPlatform;

  const isSwift = false;

  if (selectedValue?.id === 42) {
    tradingPlatform = [
      {
        value: "mt5",
        label: <div className="pmtOptions">MT5</div>,
      },
    ];
  } else if (selectedBrand?.brand === "crypto_edge") {
    tradingPlatform = [
      {
        value: "ce_terminal",
        label: <div className="pmtOptions">CE Terminal</div>,
      },
    ];
  } else if (selectedBrand?.brand === "equity_edge") {
    if (isPoland) {
      tradingPlatform = [
        {
          value: "mt5",
          label: <div className="pmtOptions">MT5</div>,
        },
      ];
    } else if (isMalaysia) {
      tradingPlatform = [
        {
          value: "mt5",
          label: <div className="pmtOptions">MT5</div>,
        },
        // Only include matchtrade if not a swift plan
        ...(!isSwift
          ? [
            {
              value: "matchtrade",
              label: <div className="pmtOptions">Match-Trader</div>,
            },
          ]
          : []),
      ];
    } else if (isUS_Canada) {
      tradingPlatform = [
        // Only include matchtrade if not a swift plan
        ...(!isSwift
          ? [
            {
              value: "matchtrade",
              label: <div className="pmtOptions">Match-Trader</div>,
            },
          ]
          : []),
      ];
    } else {
      tradingPlatform = [
        {
          value: "mt5",
          label: <div className="pmtOptions">MT5</div>,
        },
        // Only include matchtrade if not a swift plan
        ...(!isSwift
          ? [
            {
              value: "matchtrade",
              label: <div className="pmtOptions">Match-Trader</div>,
            },
          ]
          : []),
      ];
    }
  } else {
    tradingPlatform = [];
  }
  const [addonsList, setAddonsList] = useState([]);
  const [addon, setAddon] = useState();

  const fetchAddonsList = async () => {
    try {
      const response = await axios.get(`${baseUrl}/payment/addons/`);
      console.log(response);
      setAddonsList(
        response.data.map((item) => ({
          label: item.title,
          value: item.id,
        })),
      ); // Assuming the data is in response.data
    } catch (error) {
      console.error("Failed to fetch addons:", error);
    }
  };

  useEffect(() => {
    if (selectedBrand?.brand === "crypto_edge") {
      fetchAddonsList();
    }
  }, [selectedBrand]); // Add selectedBrand as a dependency

  useEffect(() => {
    if (isUS_Canada && broker === "mt5") {
      setBroker("matchtrade");
      setShowMT5Warning(true);
    } else if (!isUS_Canada) {
      setShowMT5Warning(false);
    }
  }, [selectedCountry, isUS_Canada, broker]);

  const handlePlanChange = (id) => {
    console.log(id, "iddddd");

    const selectedPlanId = id;

    const selectedPlan = plans?.find((plan) => plan.id === selectedPlanId);
    setSelectedValue(planOptions.find((plan) => plan.id === selectedPlanId));

    const selectedPlanChallenges = selectedPlan ? selectedPlan.challenges : [];

    const isInstant = selectedPlan?.name?.toLowerCase().includes("instant");
    const targetBalance = isInstant ? 100000 : 10000;

    let defaultChallenge = selectedPlanChallenges?.find((item) => Number(item?.starting_balance) === targetBalance);

    if (!defaultChallenge && selectedPlanChallenges?.length > 0) {
      defaultChallenge = selectedPlanChallenges[0];
    }

    setAccBalanceOptions(
      selectedPlanChallenges.map((item) => ({
        label: formatUSD(Number(item.starting_balance), 0),
        value: item?.starting_balance,
        id: item?.id,
      })),
    );

    if (defaultChallenge) {
      setAccBalance({
        label: formatUSD(Number(defaultChallenge.starting_balance), 0),
        value: defaultChallenge.starting_balance,
        id: defaultChallenge.id,
      });
      setCurrentChallenge(defaultChallenge);
    }
  };

  useEffect(() => {
    const challenges = plans?.flatMap((plan) => plan.challenges);
    const challenge = challenges.find((item) => item.id === selectedChallenge);

    window.scrollTo(0, 0);

    setCurrentChallenge(challenge);

    const defaultSelectedPlan = challenge ? challenge.plan : "";

    const selectedPlan = plans?.find((plan) => plan.id === defaultSelectedPlan);

    setSelectedValue(planOptions.find((plan) => plan.id === defaultSelectedPlan));
    const defaultAccBalance = challenge ? challenge.starting_balance : "";
    setAccBalance(
      {
        label: formatUSD(Number(defaultAccBalance), 0),
        value: defaultAccBalance,
        id: challenge?.id,
      } || "",
    );

    const selectedPlanChallenges = selectedPlan ? selectedPlan.challenges : [];

    setAccBalanceOptions(
      selectedPlanChallenges.map((item) => ({
        label: formatUSD(Number(item?.starting_balance), 0),
        value: item?.starting_balance,
        id: item?.id,
      })),
    );
  }, [selectedChallenge, plans]);

  useEffect(() => {
    if (currentChallenge?.id && currentChallenge.id !== Number(id)) {
      navigate(`/funding-evaluation/payments/${currentChallenge.id}`, { replace: true });
    }
  }, [currentChallenge?.id, id]);

  const handleAccBalanceChange = (e) => {
    setAccBalance(e.value);
    const selectedAccBalance = e.value;

    const currentPlan = plans?.find((plan) => plan.id === selectedValue?.id);
    const matchingChallenge = currentPlan?.challenges?.find((challenge) => challenge.starting_balance === selectedAccBalance);

    if (matchingChallenge) {
      setCurrentChallenge(matchingChallenge);

      setAccBalance({
        label: formatUSD(Number(selectedAccBalance), 0),
        value: selectedAccBalance,
        id: matchingChallenge.id,
      });
    } else {
      console.error("No matching challenge found for the selected account balance");
    }
  };

  // for public
  const [email, setEmail] = useState(null);
  const userDetails = useSelector((state) => state.user);

  const [formData, setFormData] = useState(savedCheckout?.formData || {
    first_name: userDetails?.first_name || "",
    last_name: userDetails?.last_name || "",
    email: userDetails?.email || "",
    country: userDetails?.country || "",
    contact: userDetails?.contact || "",
    country_code: userDetails?.country_code || "",
  });

  console.log("country_code", formData, userDetails?.code, formData);

  useEffect(() => {
    const checkoutDetails = {
      formData,
      addressDetails,
      selectedCountry,
      selectedState,
      countryCode,
      broker,
      paymentMethodValue: paymentMethod?.value,
      selectRapydCountry,
      selectPaymidCountry,
    };
    localStorage.setItem("checkout_details", JSON.stringify(checkoutDetails));
  }, [
    formData,
    addressDetails,
    selectedCountry,
    selectedState,
    countryCode,
    broker,
    paymentMethod,
    selectRapydCountry,
    selectPaymidCountry,
  ]);

  useEffect(() => {
    // Clear the flag on mount so that subsequent refreshes or page changes start clean
    localStorage.removeItem("payment_in_progress");
  }, []);

  const idToken = useSelector((state) => state.auth.idToken);

  const handleSave = async () => {
    let config = {
      headers: { Authorization: `Bearer ${idToken}` },
    };
    const respo = await axios
      .patch(`${baseUrl}/user/profile/`, formData, config)
      .then(async (res) => {
        // const msg = "Updated Successfully";
        // const status = res.status;
        // dispatch(returnMessages(msg, status));
        const profileData = await getUserDetails(idToken);
        dispatch(setUser(profileData));
        return profileData;
      })
      .catch((error) => {
        const msg = "error";
        const status = 500;
        dispatch(returnErrors(msg, status));
      });
    return respo;
  };

  const sequrePaymentLink = paymentAsPerPlan
    .map((item, index) => {
      return item.step === selectedValue?.value && item.amount === accBalance?.value ? item?.link : null;
    })
    .join("");
  const [isRefundPolicy, setIsRefundPolicy] = useState(false);
  const [open, setOpen] = useState(false);

  const handleConfirmClose = () => {
    setOpen(false);
    setBroker("matchtrade");
    setIsRefundPolicy(false);
  };

  const handleContinue = () => {
    if (isRefundPolicy) {
      setOpen(false);
      // setBroker("tradelocker");
      setIsRefundPolicy(false);
    }
  };

  const { country } = useSelector((state) => state.user);
  // const country = "United States";

  const [openCoinPaymentsModal, setOpenCoinPaymentsModal] = useState(false);
  const handleClose = () => setOpenCoinPaymentsModal(false);
  useEffect(() => {
    if (broker === "tradelocker") {
      const filteredOptions = accBalanceOptions.filter((item) => Number(item.value) !== 5000 && Number(item.value) !== 2500);
      if (filteredOptions.length > 0 && !filteredOptions.includes(accBalance)) {
        setAccBalance(filteredOptions[0]); // or whichever default you want
      }
    }
  }, [broker]);

  // Ensure broker is always set to the first available tradingPlatform when plan or tradingPlatform changes
  useEffect(() => {
    if (tradingPlatform && tradingPlatform?.length > 0) {
      // If broker is not in the available options, or not set, set it to the first available
      if (!tradingPlatform.some((item) => item.value === broker)) {
        setBroker(tradingPlatform && tradingPlatform[0].value);
      }
    }
    // Only run when selectedValue or tradingPlatform changes
  }, [selectedValue, tradingPlatform]);

  useEffect(() => {
    setBroker(state?.value || state);
    selectedBrand?.brand === "crypto_edge" && setBroker("ce_terminal");
  }, [state, selectedBrand, selectedValue]);

  return (
    <div className="buy_funded_container">
      <div className="step_1">
        {/* <div className="heading">
          <h1>Step 1</h1>
        </div> */}
        <div className="first_selector">
          <div className="mainPayment_method">
            <span>Payment Method</span>
            <div>
              <Select
                isSearchable={false}
                value={paymentMethod}
                options={options1}
                styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                className="react-select-container"
                classNamePrefix="react-select"
                onChange={(selectedOption) => handlePaymentMethodChange(selectedOption)}
                components={{
                  IndicatorSeparator: () => null,
                }}
              // menuIsOpen={true}
              />
            </div>
            {/* <div className="paymentMethodsOptions">
            {options1?.map((item, index) => {
              if (
                (country !== "United States" && selectedCountry?.label !== "United States") ||
                ((country === "United States" || selectedCountry?.label === "United States") && item.value !== "fibonatix")
              ) {
                return (
                  <div
                    className={`paymentOption ${paymentMethod?.value === item?.value ? "activePayment" : ""}`}
                    onClick={() => handlePaymentMethodChange(item)}
                  >
                    {item?.label}
                  </div>
                );
              }
              return null;
            })}
          </div> */}
          </div>

          {paymentMethod.value === "coinpayments" && (
            <>
              <div className="challange_type">
                <h3>Coin Payments</h3>
                <div>
                  <Select
                    isSearchable={false}
                    value={paymentMode}
                    options={paymentModeOptions}
                    styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    onChange={(selectedOption) => handlePaymentModChange(selectedOption)}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
              </div>
            </>
          )}

          <div className="challange_type">
            <h3>Challenge Type</h3>
            <div>
              <Select
                isSearchable={false}
                value={selectedValue}
                options={publicCheckout ? planOptions.filter((plan) => plan.value !== "Free Trial") : planOptions}
                styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                className="react-select-container"
                classNamePrefix="react-select"
                onChange={(selectedOption) => {
                  handlePlanChange(selectedOption.id);
                  if (selectedOption.id === 13) {
                    setBroker("matchtrade");
                  }
                }}
                // menuIsOpen={true}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            </div>
          </div>
          <div className="challange_amount">
            <h3>Account Size</h3>
            <div>
              <Select
                isSearchable={false}
                value={accBalance}
                options={accBalanceOptions.filter((item) => {
                  // Exclude 5000 and 2500 when broker is "tradelocker"
                  if (broker === "tradelocker" && (Number(item.value) === 5000 || Number(item.value) === 2500)) {
                    return false;
                  }
                  return true;
                })}
                styles={
                  selectedBrand?.brand === "equity_edge"
                    ? newSelectorStyles(50, "#fff", "#fff", "none")
                    : selectedBrand?.brand === "crypto_edge"
                      ? newCryptoSelectorStyles(50, "#fff", "#fff", "none")
                      : newSelectorStyles(50, "#fff", "#fff", "none")
                }
                className="react-select-container account-size-select"
                classNamePrefix="react-select"
                onChange={handleAccBalanceChange}
                components={{
                  IndicatorSeparator: () => null,
                }}
              // menuIsOpen={true}
              />
            </div>
          </div>
          <div className="choose_trading_platform">
            <h3>Choose Trading Platform</h3>
            <div>
              <Select
                isSearchable={false}
                value={tradingPlatform.find((item) => item.value === broker)}
                options={tradingPlatform}
                styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                className="react-select-container"
                classNamePrefix="react-select"
                onChange={(selectedOption) => {
                  setBroker(selectedOption.value);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            </div>
            {showMT5Warning && (
              <div className="mt5-warning">
                <span className="warning-icon">⚠</span>
                <span className="warning-text">MT5 is not available for your country. Match-Trader has been selected.</span>
              </div>
            )}
            {/* <div className="tradingPlatformsOptions">
            {tradingPlatform?.map((item, index) => {
              return (
                <div
                  key={item?.value || index}
                  className={`tradingOption ${broker === item.value ? "activeTradingPlatform" : ""}`}
                  onClick={() => handleBroker(item)}
                >
                  {item?.label}
                </div>
              );
            })}
          </div> */}
          </div>
          {selectedBrand?.brand === "crypto_edge" && (
            <div
              className="choose_trading_platform"
              style={{ gridColumn: "span 2" }}
            >
              <h3>Add-On (Optional)</h3>
              <div>
                <Select
                  isSearchable={false}
                  value={addon ? addonsList.find((item) => item.value === addon) : null}
                  options={addonsList}
                  styles={selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  onChange={(selectedOption) => {
                    setAddon(selectedOption.value);
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {/* <div className="second_selector"></div> */}
        <div className="fll_details">
          {paymentMethod.value === "fibonatix" || paymentMethod.value === "paytiko" || paymentMethod.value?.toLowerCase() === "paymid" ? (
            <div className="payment_method">
              <h3>Country</h3>
              <div>
                <Select
                  options={
                    paymentMethod.value === "paytiko"
                      ? rapydCountry?.filter((item) => item.value !== "ET")
                      : paymentMethod.value?.toLowerCase() === "paymid"
                        ? paymidCountry
                        : countryOptions
                  }
                  value={
                    paymentMethod.value === "paytiko"
                      ? selectRapydCountry
                      : paymentMethod.value?.toLowerCase() === "paymid"
                        ? selectPaymidCountry
                        : selectedCountry
                  }
                  styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  onChange={(option) => {
                    if (paymentMethod.value === "paytiko") {
                      setSelectRapydCountry(option);
                      handleCountryChange(option);
                    } else if (paymentMethod.value?.toLowerCase() === "paymid") {
                      setSelectPaymidCountry(option);
                      handleCountryChange(option);
                    } else {
                      handleCountryChange(option);
                    }
                  }}
                />
              </div>
            </div>
          ) : publicCheckout ? (
            <div className="payment_method">
              <h3>Country</h3>
              <div>
                <Select
                  // isSearchable={false}
                  // options={paymentMethod.value === "rapyd" ? rapydCountry : countryOptions}
                  // value={paymentMethod.value === "rapyd" ? selectRapydCountry : selectedCountry}
                  options={countryOptions}
                  value={selectedCountry}
                  styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  onChange={handleCountryChange}
                />
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* {paymentMethod.value === "fibonatix" && selectedCountry?.states?.length > 0 && ( */}
          {paymentMethod.value === "fibonatix" && selectedCountry?.states?.length > 0 && (
            <div className="payment_method">
              <h3>State</h3>
              <div>
                <Select
                  // isSearchable={false}
                  options={stateOptions.filter((item) => item)}
                  value={selectedState}
                  styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  onChange={handleStateChange}
                />
              </div>
            </div>
          )}

          {paymentMethod.value === "fibonatix" && (
            <>
              <div className="account_input new">
                <label htmlFor="zip_code">ZIP/Postal Code</label>

                <div className={`account_input_wrapper `}>
                  <input
                    className="account_details_input"
                    type="text"
                    value={addressDetails.zipCode}
                    placeholder="Zip Code"
                    required
                    onChange={(e) => setAddressDetails({ ...addressDetails, zipCode: e.target.value })}
                  />
                </div>
              </div>
            </>
          )}

          {(paymentMethod.value === "fibonatix" || paymentMethod.value === "paytiko" || paymentMethod.value?.toLowerCase() === "paymid") && (
            <div className="account_input new">
              <label
                htmlFor="city"
              //  className="label_black"
              >
                City
              </label>

              <div className={`account_input_wrapper `}>
                <input
                  className="account_details_input"
                  type="text"
                  value={addressDetails.city}
                  placeholder="City"
                  required
                  onChange={(e) => setAddressDetails({ ...addressDetails, city: e.target.value })}
                />
              </div>
            </div>
          )}
          {paymentMethod.value === "fibonatix" ? (
            <div className="account_input new">
              <label htmlFor="phone">Phone Number</label>

              <div className={`account_input_wrapper `}>
                <input
                  className="account_details_input"
                  type="text"
                  value={addressDetails.phone}
                  placeholder="+1 234 567 8900"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 15) {
                      setAddressDetails({ ...addressDetails, phone: value });
                    }
                  }}
                  required

                // disabled={editMode}
                />
              </div>
            </div>
          ) : publicCheckout ? (
            <div className="account_input new">
              <label htmlFor="firstName">Phone</label>

              <div className={`account_input_wrapper `}>
                <input
                  className="account_details_input"
                  type="text"
                  value={addressDetails.phone}
                  placeholder="Phone"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setAddressDetails({ ...addressDetails, phone: value });
                  }}
                  required

                // disabled={editMode}
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>

        {!publicCheckout &&
          Object.entries(formData)
            .filter(([key]) => key !== "country_code") // exclude country_code
            .some(([_, value]) => !value || value.toString().trim() === "") ? (
          <div className="profile_header">
            <hr />
            <p>Please fill profile details</p>
          </div>
        ) : null}

        <div className="invoice_details">
          <div className="addressSelecotorCon">
            {!userDetails?.email ? (
              <div className="userDetails">
                {/* <img
                    src={EmailIcon}
                    alt=""
                    className="input_icon"
                  /> */}

                <label
                  className="general_info_label"
                  htmlFor="email"
                >
                  Email Address
                </label>
                <div className="general_info_input">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    autocomplete="off"
                    placeholder="Email Address"
                    value={formData?.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    style={{ width: "100% !important" }}
                  // onBlur={handleBlur}
                  // onFocus={handleFocus}
                  />

                  <div className="signinform-container_icon">
                    {validateEmail(email) && (
                      <img
                        src={CheckSolidGreenIcon}
                        alt=""
                        className="signinform-icon"
                      />
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}

            {/* First Name input if missing */}
            {!userDetails?.first_name && (
              <div className="userDetails">
                <label
                  className="general_info_label"
                  htmlFor="first_name"
                >
                  First Name
                </label>
                <div className="general_info_input">
                  <input
                    type="text"
                    name="first_name"
                    id="first_name"
                    autoComplete="off"
                    placeholder="First Name"
                    value={formData?.first_name || ""}
                    onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                    style={{ width: "100% !important" }}
                  />
                </div>
              </div>
            )}

            {/* Last Name input if missing */}
            {!userDetails?.last_name && (
              <div className="userDetails">
                <label
                  className="general_info_label"
                  htmlFor="last_name"
                >
                  Last Name
                </label>
                <div className="general_info_input">
                  <input
                    type="text"
                    name="last_name"
                    id="last_name"
                    autoComplete="off"
                    placeholder="Last Name"
                    value={formData?.last_name || ""}
                    onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                    style={{ width: "100% !important" }}
                  />
                </div>
              </div>
            )}

            {/* Country selector if missing */}
            {!userDetails?.country && (
              <div className="userDetails">
                <label
                  className="general_info_label"
                  htmlFor="country"
                >
                  Country
                </label>
                <Select
                  options={countryOptions.map((item) => ({ ...item, value: item.label }))} // from your transformed data
                  value={selectedCountry}
                  onChange={(option) => {
                    handleCountryChange(option); // your existing logic
                  }}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : newCryptoSelectorStyles(50)}
                />
              </div>
            )}

            {/* Contact Number input if missing */}
            {!userDetails?.contact && (
              <div className="userDetails">
                <label
                  className="general_info_label"
                  htmlFor="phone"
                >
                  Contact Number
                </label>
                <div className="general_info_input">
                  <input
                    type="text"
                    name="contact"
                    id="contact"
                    autoComplete="off"
                    placeholder="Contact Number"
                    value={formData.contact}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 15) {
                        setFormData({ ...formData, contact: value });
                      }
                    }}
                    style={{ width: "100% !important" }}
                  />
                </div>
              </div>
            )}

            {/* Country code field if missing or needs to be set */}
            {!userDetails?.country_code && (
              <div className="userDetails">
                <label
                  className="general_info_label"
                  htmlFor="country_code"
                >
                  Country Code
                </label>
                <div className="general_info_input">
                  <input
                    type="text"
                    name="country_code"
                    id="country_code"
                    placeholder="Country Code"
                    value={formData?.country_code || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\+?\d*$/.test(value) && value.replace("+", "").length <= 6) {
                        setFormData({ ...formData, country_code: value });
                      }
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            )}
          </div>

          {!publicCheckout ? (
            <InvoiceDetails
              setFormData={setFormData}
              formData={formData}
              selectedAddress={selectedAddress}
              setSelectedAddress={setSelectedAddress}
              paymentMethod={paymentMethod}
            />
          ) : (
            <></>
          )}
        </div>
      </div>

      <div className="step_2">
        <Summary
          user={user}
          email={email}
          formData={formData}
          publicCheckout={publicCheckout}
          paymentMethod={paymentMethod}
          selectedCountry={selectedCountry}
          selectedState={selectedState ? selectedState : null}
          addressDetails={addressDetails}
          selectedValues={selectedValue}
          accBalances={accBalance}
          selectedAddress={selectedAddress}
          handleSave={handleSave}
          paymentMode={paymentMode}
          sequrePaymentLink={sequrePaymentLink}
          setEmail={setEmail}
          broker={broker}
          selectRapydCountry={selectRapydCountry}
          selectPaymidCountry={selectPaymidCountry}
          addon={addon}
          setAddon={setAddon}
        />
      </div>
      {open && broker !== "tradelocker" && (
        <>
          <div
            className="confirm_overlay"
            onClick={(e) => e.stopPropagation()} // Prevent overlay from closing unintentionally
          >
            <div className="confirm_container">
              <div className="confirm_container_top">
                <p className="confirmation_message">Please confirm you understand that Equity Edge will not be releasing TradeLocker credentials, this is a prelaunch offering prior to our merger.</p>
                <div className="term">
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={isRefundPolicy}
                    onChange={() => setIsRefundPolicy((prev) => !prev)}
                  />
                  <span>I understand this is a presale, and I wish to continue</span>
                </div>
              </div>
              <div className="confirm_container_bottom">
                <button
                  className="confirm_close_btn"
                  onClick={handleConfirmClose}
                >
                  Cancel
                </button>
                <button
                  className="confirm_close_btn"
                  onClick={handleContinue}
                  style={{ backgroundColor: isRefundPolicy ? "#34d068" : "#2e3035", color: !isRefundPolicy ? "#FFF" : "#000" }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BuyFundedAc;
